"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteStatus = void 0;
exports.QuoteStatus = {
    CREATED: 'CREATED',
    BOOKED: 'BOOKED',
    INELIGIBLE: 'INELIGIBLE'
};
//# sourceMappingURL=quote-status.js.map